import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { pillarArticles } from "@/mocks/pillarArticles";

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t("pillar.title")}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base text-foreground-600">
            {t("pillar.subtitle")}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {pillarArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-all hover:-translate-y-0.5 cursor-pointer flex flex-col"
            >
              <div className="h-44 md:h-48 w-full overflow-hidden">
                <img
                  src={article.image}
                  alt={t(`pillar.${idx}.title`)}
                  title={t(`pillar.${idx}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <span className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-0.5 text-[11px] font-semibold text-accent-700">
                  {t(article.tagKey)}
                </span>
                <h3 className="mt-2 font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-2">
                  {t(`pillar.${idx}.title`)}
                </h3>
                <div className="mt-auto pt-3 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readingTime} {t("readingTime")}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                    {t("pillar.readMore")}
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}